import * as Factory from 'factory.ts'
import faker from 'faker'

import { AccountMock } from './account.factory'
import { PayCardMock } from './payCard.factory'
import { PayCardholderMock } from './payCardholder.factory'
import { PayFundStatus } from '../../models/enums/PayFundStatus'
import { type PayFund } from '../../models/PayFund'

export const PayFundMock = Factory.Sync.makeFactory<PayFund>({
  id: Factory.each(() => faker.random.number()),
  uuid: Factory.each(() => faker.random.uuid()),
  title: Factory.each(() => faker.lorem.words()),
  reason: Factory.each(() => faker.lorem.sentence()),
  status: PayFundStatus.OPEN,
  logs: [],
  card: Factory.each(() => PayCardMock.build()),
  cardholder: Factory.each(() => PayCardholderMock.build()),
  account: Factory.each(() => AccountMock.build()),
  amount: Factory.each(() => faker.finance.amount()),
  date_created: Factory.each(() => faker.date.past(10).toISOString()),
  allocated_amount: Factory.each(() => faker.finance.amount()),
  allocated_transaction_count: Factory.each(() => faker.random.number()),
  remaining_amount: Factory.each(() => faker.finance.amount()),
})
